import "@aws-amplify/ui-react/styles.css";
import React from "react";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import { PostData } from "../clients/data-service";
import { PostEditor } from "../controls/PostEditor";
import { Stack } from "@chakra-ui/react";
import { getPost } from "../clients/posts-client";
import PageTitle from "../controls/PageTitle";
import { LoadingPage } from "../controls/LoadingPage";

class Compose extends React.Component<{}, {postData?: PostData}> {

    postId: string|undefined;

    constructor(props) {
        super(props);
        this.state = {
        };
        
        const location = window.location;
        const paths = location.pathname.split('/').filter(s => s.length > 0);
        this.postId = undefined;
        if (paths.length > 1)
        {
            this.postId = paths[1];
        }

        if (this.postId){
            const postId = this.postId;
            async function LoadData(comp) {
                const postData = await getPost(postId);
                comp.setState({postData: postData});
            }
            LoadData(this);
        }
    }

    render() {
        const pageTitle = this.postId != null ? "Update Post" : "Compose New Post";
        if (this.postId != null && this.state.postData == null) {
            return <LoadingPage pageTitle={pageTitle} />;
        }

        // if (this.state.liveDescriptor.id == null) {
        //     return <NotFound message="Image Not Found" />;
        // }
        return (<>
            <PageTitle>{pageTitle}</PageTitle>
            <Stack padding={20} pt={0}>
                <PostEditor postId={this.postId} postData={this.state.postData} />
            </Stack></>
        );
    }
}

export default Compose;